import BuzonSugerenciaPublicComponent from '@/components/rrhh/BuzonSugerenciaPublicComponent'
import BuzonSugerenciasFormComponent from '@/components/rrhh/buzon_sugerencias/BuzonSugerenciasFormComponent'


export default [{
    path: '/rrhh/buzon-sugerencias/public',
    name: 'rrhh-buzon-suegerencias-public',
    component: BuzonSugerenciaPublicComponent,
    meta: {
        requiresAuth: false
    }
}, {
    path: '/rrhh/buzon-sugerencias/',
    name: 'rrhh-buzon-suegerencias',
    component: BuzonSugerenciasFormComponent,
    meta: {
        requiresAuth: true
    }
},

]